import React, { useState } from 'react';
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Divider,
  Link,
} from '@mui/material';

function ArticleItem({ title, url, authors, journal_name, volume, issue, publish_date, backgroundColor, type }) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Box
        sx={{
          mb: 2,
          pb: 1,
          borderBottom: '1px solid #eee',
          backgroundColor,
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: 'grey.100',
          },
          p: 2,
        }}
        onClick={handleClickOpen}
      >
        <Link
          href={url}
          underline="hover"
          color="primary"
          sx={{
            fontWeight: 600,
            display: 'block',
            fontSize: '1rem',
            fontFamily: 'Poppins, sans-serif',
          }}
          onClick={(e) => {
            e.stopPropagation(); // Prevent opening the dialog when clicking the link
          }}
          // target="_blank"
          // target="_blank"
        >
          {title}
        </Link>

        {Array.isArray(authors) && authors.length > 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Authors:{' '}
            {authors.map((author, i) => (
              <Link
                key={author.id + '-' + i}
                href={`/author?id=${author.id}&name=${encodeURIComponent(author.name)}`}
                underline="always"
                sx={{ mx: 0.5, cursor: 'pointer' }}
                // target="_blank"
                // target="_blank"
                onClick={(e) => e.stopPropagation()}
              >
                {author.name}
                {i < authors.length - 1 && ','}
              </Link>
            ))}
          </Typography>
        )}
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        scroll="paper"
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: '1.25rem' }}>
          Article Details
        </DialogTitle>

        <DialogContent dividers>
          <Stack spacing={2}>
            <Box>
              <Typography variant="subtitle2" fontWeight={600}>Title:</Typography>
              <Typography variant="body2">{title}</Typography>
            </Box>

            <Divider />

            <Box>
              <Typography variant="subtitle2" fontWeight={600}>Author(s):</Typography>
              {Array.isArray(authors) && authors.length > 0 ? (
                <Typography variant="body2">
                  {authors.map((author, i) => (
                    <Link
                      key={author.id + '-dialog-' + i}
                      href={`/author?id=${author.id}&name=${encodeURIComponent(author.name)}`}
                      underline="hover"
                      // target="_blank"
                      // target="_blank"
                      sx={{ mx: 0.5 }}
                    >
                      {author.name}
                      {i < authors.length - 1 && ','}
                    </Link>
                  ))}
                </Typography>
              ) : (
                <Typography variant="body2">N/A</Typography>
              )}
            </Box>

            <Box>
              <Typography variant="subtitle2" fontWeight={600}>Journal:</Typography>
              <Typography variant="body2">{journal_name}</Typography>
            </Box>

            <Box>
              <Typography variant="subtitle2" fontWeight={600}>Volume / Issue:</Typography>
              <Typography variant="body2">
                {volume} / {issue}
              </Typography>
            </Box>

            <Box>
              <Typography variant="subtitle2" fontWeight={600}>Published on:</Typography>
              <Typography variant="body2">{publish_date}</Typography>
            </Box>
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="inherit">Close</Button>
          <Button
            href={url}
            // target="_blank"
            variant="contained"
            sx={{ textTransform: 'none' }}
          >
            View or Download
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ArticleItem;
